import Clickable from '@ms/yammer-web-core-ui/dist/components/Clickable';
import Flex from '@ms/yammer-web-core-ui/dist/components/Flex';
import { Tooltip } from '@ms/yammer-web-core-ui/dist/fluent9/components/Tooltip';
import type { FC, ReactNode } from 'react';
import React from 'react';

const collapsedRailIconButtonSize = 36;

export interface CollapsedRailIconButtonProps {
  readonly ariaLabel: string;
  readonly icon: ReactNode;
  readonly onClick: () => void;
  readonly ariaExpanded?: boolean;
}

const CollapsedRailIconButton: FC<CollapsedRailIconButtonProps> = ({ ariaLabel, icon, onClick, ariaExpanded }) => (
  <Tooltip content={ariaLabel} relationship="description" positioning="before">
    <div>
      <Clickable ariaLabel={ariaLabel} ariaExpanded={ariaExpanded} onClick={onClick} unstyled={true}>
        <Flex
          alignItems="center"
          justifyContent="center"
          width={collapsedRailIconButtonSize}
          height={collapsedRailIconButtonSize}
        >
          {icon}
        </Flex>
      </Clickable>
    </div>
  </Tooltip>
);

export default CollapsedRailIconButton;
